module.exports = __webpack_public_path__ + "static/embed-sketch@2x-a103d62b5f664f77fa162a6698bb46c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketch/embed-sketch@2x.jpg
// module id = 448
// module chunks = 131293461488081 145262073310797 281043220932899